export default __webpack_public_path__ + "static/media/article_ad.ffe4cf9a.png";